"use client"

import React from "react"

import { SearchIcon } from "components/SVG"
import { ToggleButton } from "components/SiteChrome/ToggleButton"
import { colours } from "@shared/ui.design-system"

import { searchButton } from "../Header.css"
import { useSegment } from "tracking"

export const SearchToggleButton = () => {
  const { track } = useSegment()

  return (
    <ToggleButton
      aria-controls="search-panel"
      className={searchButton}
      aria-label="open search"
      data-testid="search-button-mobile"
      onClick={() => {
        track({
          event: "Page Element Clicked",
          properties: {
            module_content: "Search",
            location_type: "Input",
          },
        })
      }}
    >
      <SearchIcon fill={colours.primary.dark} />
      <p>Search</p>
    </ToggleButton>
  )
}
